import { BellNotification, LogOut, NavArrowDown, Settings, User } from 'iconoir-react'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { FAIL, LOADING, SUCCESS } from '../../redux_store/actionTypes'
import { getAdminDetails } from '../../redux_store/asyncConfig'
import { clearAuthState } from '../../redux_store/auth/auth_slice'
import { userLogout } from '../../redux_store/auth/auth_thunk'
import NotificationPanel from '../pages/notification/NotificationPanel'
import LoadingModal from '../templates/modals/LoadingModal'
import toast from '../templates/ToastMessage'

const Navbar = () => {
  const [dropdownState, setDropdownState] = useState(false);
  const dispatch = useDispatch();
  const [showNotification, setShowNotification] = useState(false);
  const [adminPic, setAdminPic] = useState('');
  const [adminName, setAdminName] = useState('');
  const { status, authState, message } = useSelector((state) => state.auth);
  const navigator = useNavigate();

  useEffect(() => {
    const user = getAdminDetails();
    if (user) {
      setAdminPic(user.profile_pic);
      setAdminName(user.surname || 'Admin');
    }
  }, [authState]);

  const handleImgToggle = () => {
    setDropdownState(!dropdownState);
  }

  useEffect(() => {
    if (status === FAIL && authState === 'LOGOUT') {
      toast({ message, status });
    } else if (status === SUCCESS && authState === 'LOGOUT') {
      dispatch(clearAuthState());
      toast({ message, status });
      navigator('/');
    }
    dispatch(clearAuthState());
    // eslint-disable-next-line
  }, [status]);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownState && !e.target.closest('.profile-dropdown')) {
        setDropdownState(false);
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, [dropdownState]);

  return (
    <header className='sticky top-0 z-30 w-full bg-white/80 backdrop-blur-lg border-b border-surface-100'>
      {status === LOADING && <LoadingModal message={'Please wait...'} />}
      {showNotification && <NotificationPanel
        onNewNotification={() => {
          setShowNotification(false);
        }}
        notifications={['', '', '', '']}
        onPanelClose={() => setShowNotification(false)}
      />}

      <div className='flex items-center justify-between h-16 px-6'>
        {/* Left side - Breadcrumb or Search could go here */}
        <div className='flex items-center gap-4'>
          <h2 className='text-lg font-semibold text-surface-700'>
            Good {new Date().getHours() < 12 ? 'morning' : new Date().getHours() < 17 ? 'afternoon' : 'evening'}, {adminName}!
          </h2>
        </div>

        {/* Right side - Actions */}
        <div className='flex items-center gap-2'>
          {/* Notifications */}
          <button
            onClick={() => setShowNotification(true)}
            className='relative p-2.5 rounded-xl text-surface-500 hover:bg-surface-100 hover:text-surface-700 transition-all duration-200'
          >
            <BellNotification strokeWidth={2} className='w-5 h-5' />
            {/* Notification badge */}
            <span className='absolute top-2 right-2 w-2 h-2 bg-danger-500 rounded-full animate-pulse' />
          </button>

          {/* Divider */}
          <div className='w-px h-8 bg-surface-200 mx-2' />

          {/* Profile Dropdown */}
          <div className='relative profile-dropdown'>
            <button
              onClick={handleImgToggle}
              className='flex items-center gap-3 p-1.5 pr-3 rounded-xl hover:bg-surface-100 transition-all duration-200'
            >
              <div className='relative'>
                <img
                  alt='profile_pic'
                  src={adminPic}
                  className="w-9 h-9 rounded-xl object-cover ring-2 ring-surface-200"
                />
                {/* Online indicator */}
                <span className='absolute -bottom-0.5 -right-0.5 w-3 h-3 bg-success-500 border-2 border-white rounded-full' />
              </div>
              <NavArrowDown
                strokeWidth={2}
                className={`w-4 h-4 text-surface-400 transition-transform duration-200 ${dropdownState ? 'rotate-180' : ''}`}
              />
            </button>

            {/* Dropdown Menu */}
            {dropdownState && (
              <div className='dropdown-menu'>
                <div className='px-4 py-3 border-b border-surface-100'>
                  <p className='text-sm font-semibold text-surface-800'>{adminName}</p>
                  <p className='text-xs text-surface-400'>Administrator</p>
                </div>

                <div className='py-1'>
                  <button
                    onClick={() => {
                      navigator('/profile');
                      handleImgToggle();
                    }}
                    className='dropdown-item flex items-center gap-3'
                  >
                    <User strokeWidth={2} className='w-4 h-4' />
                    <span>View Profile</span>
                  </button>

                  <button
                    onClick={() => {
                      navigator('/settings');
                      handleImgToggle();
                    }}
                    className='dropdown-item flex items-center gap-3'
                  >
                    <Settings strokeWidth={2} className='w-4 h-4' />
                    <span>Settings</span>
                  </button>
                </div>

                <div className='border-t border-surface-100 py-1'>
                  <button
                    onClick={() => {
                      dispatch(userLogout());
                      handleImgToggle();
                    }}
                    className='dropdown-item flex items-center gap-3 text-danger-600 hover:bg-danger-50'
                  >
                    <LogOut strokeWidth={2} className='w-4 h-4' />
                    <span>Sign out</span>
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  )
}

export default Navbar
